import faker from 'faker';

import {
  IWorkflowTransition,
  IWorkflowTransitionData
} from '../workflow.types';
import { WorkflowTransition } from '../workflow';
import { createRange } from '@/utils/helpers';

export function createRandomWorkflowTransition(): IWorkflowTransitionData {
  return {
    id: faker.datatype.number(),
    name: faker.random.word(),
    source_state: faker.datatype.number(),
    target_state: faker.datatype.number(),
    nodes: []
  };
}

export const mockWorkflowTransitionsData: IWorkflowTransitionData[] = createRange(
  6
).map(() => createRandomWorkflowTransition());

export const mockWorkflowTransitions = (
  data: IWorkflowTransitionData[] = mockWorkflowTransitionsData
): IWorkflowTransition[] => data.map(item => new WorkflowTransition(item));
